var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",attrs:{"tabindex":"0"}},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.img,"alt":" "}})]),_vm._v(" "),_c('div',{staticClass:"aboutInsu "},[_c('h3',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.description)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c79285","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardsInsurance.vue
// module id = 37
// module chunks = 0